import styled from "styled-components";
import {
  LOGO_HOME,
  SyncFilled,
} from "@assets";

export const Bar = styled.div`
  height: 70px;
  padding-inline: 16px;
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px -1px,
		rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px;
  z-index: 1000;
  background: linear-gradient(273.28deg, #AA5E1B 0%, #FFD648 100.27%);

@media screen and (max-width: 380px) {
  gap: 6px;
}

@media screen and (max-width: 330px) {
  gap: 4px;
}
`;

export const Logo = styled(LOGO_HOME)`

@media screen and (max-width: 380px) {
  width: 70px;
}

@media screen and (max-width: 320px) {
  width: 55px;
}
`;

export const IconsWrapper = styled.div`
display: flex;
gap: 8px;
align-items: center;
justify-content: flex-end;

svg {
  cursor: pointer;
}

@media screen and (max-width: 380px) {
  gap: 6px;
}

@media screen and (max-width: 330px) {
  gap: 4px;

  svg {
    width: 20px;
  }
}
`;

export const Icon = styled.div`
display: flex;
gap: 4px;
align-items: center;
justify-content: center;
width: 32px;
height: 32px;
border-radius: 100px;
background: rgba(0, 0, 0, 0.30);
cursor: pointer;
`;

export const IconTextWrapper = styled(Icon)`
width: auto;
padding: 0 8px 0 6px;


@media screen and (max-width: 380px) {
  padding: 0 6px 0 4px;
  gap: 2px;

  svg {
    width: 18px;
  }
}

@media screen and (max-width: 320px) {
  padding: 0 4px 0 2px;
  gap: 0px;

  svg {
    width: 14px;
  }
}
`;

export const IconText = styled.div`
color: #F4F4F4;
font-size: 12px;
font-style: normal;
font-weight: 700;
line-height: 1.5;

@media screen and (max-width: 380px) {
  font-size: 10px;
}
`;

export const TextWrapper = styled.div`
position: relative;
flex: 1;
display: flex;
gap: 2px;
height: 42px;
flex-direction: column;
align-items: flex-end;
justify-content: flex-end;
margin-right: 4px;
`;

export const Text = styled.div`
color: #2A2A2A;
font-size: 10px;
font-style: normal;
font-weight: bold;
line-height: 1.5;
`;

export const BoldText = styled(Text)`
font-weight: bold;
font-size: 14px;
min-height: 21px;

@media screen and (max-width: 380px) {
font-size: 12px;
}

@media screen and (max-width: 320px) {
font-size: 11px;
}
`;

export const ReloadIcon = styled(SyncFilled)`
margin-right: 12px;
cursor: pointer;
width: 14px;
margin-bottom: -3px;
`;